module.exports = __webpack_public_path__ + "static/media/visa.36f2837a.png";